import React, { ReactElement } from 'react';
import { Button } from 'react-bootstrap';
import contactUsIcon from 'assets/images/icons/contact-us.svg';

import './index.css';
import MainModal, { ModalChildProps } from '../MainModal';
import CreditLineForm from '../CreditLineForm';
import { useBrand } from 'core/contexts/BrandContext';

export interface PropsAskCredit {
  className?: string;
  children?: React.ReactNode;
}

export const AskCredit = (props: PropsAskCredit): ReactElement => {
  const [show, setShow] = React.useState<boolean>(false);
  const { name: site, features, urls } = useBrand();

  const handleClick = () => {
    if (features.hasExternalCreditProduct && urls.externalCreditUrl) {
      window.location.href = urls.externalCreditUrl;
    } else {
      setShow(true);
    }
  };

  return (
    <>
      {props.children ? (
        <Button
          className={`btn-lg btn-block text-center ask-credit btn-danger ${props.className}`}
          onClick={handleClick}
          style={{ borderRadius: '50rem' }}
        >
          {props.children}
        </Button>
      ) : (
        <div 
          className="modern-product-card ask-credit-card d-flex flex-column align-items-center text-center p-4"
          style={{ backgroundColor: '#e32b2b', borderColor: '#e32b2b' }}
        >
          <div className="product-icon-wrapper mb-3 d-flex align-items-center justify-content-center" style={{ width: '72px', height: '72px' }}>
            <img 
              src={contactUsIcon} 
              alt={`Solicitar ${site}`} 
              className="product-icon-img" 
              style={{ width: '56px', height: '56px', objectFit: 'contain' }} 
            />
          </div>
          <h4 className="product-card-title title-bryant mb-2 w-100 text-white" style={{ textAlign: 'center', fontSize: '1.6rem' }}>
            Solicita tu {site}
          </h4>
          <p className="product-card-description mb-4 w-100 text-white" style={{ fontSize: '0.95rem', textAlign: 'center', opacity: 0.9 }}>
            Obtén financiamiento rápido, ágil y sin complicaciones.
          </p>
          <Button
            onClick={handleClick}
            className="w-100 mt-auto title-bryant"
            style={{ 
              backgroundColor: '#ffffff', 
              color: '#e32b2b', 
              padding: '0.75rem 1.5rem', 
              minHeight: 'auto', 
              border: 'none', 
              borderRadius: '50rem', 
              fontWeight: 700,
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(0.98)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            Solicitar ahora
          </Button>
        </div>
      )}
      <MainModal
        title="Datos personales"
        show={show}
        onHide={() => setShow(false)}
        render={(props: ModalChildProps) => (
          <CreditLineForm onHide={props.onHide} />
        )}
      />
    </>
  );
};
